import React from "react";
import { ApplicantHome } from "./applicant/Home";
import { EventDetail } from "./applicant/EventDetail";
import { ApplicantAuth } from "./applicant/Auth";
import { ApplicationForm, ApplicationPreview, SubmissionSuccess } from "./applicant/ApplicationFlow";
import { ApplicantCertificate, ApplicantDashboard, TrackingPage } from "./applicant/ApplicantDashboard";
import { ApplicationRecord, View } from "../types/system";
type Props = {
  view: View;
  onNavigate: (v: View) => void;
  published: boolean;
  applications: ApplicationRecord[];
};
export function ApplicantPages({
  view,
  onNavigate,
  published,
  applications
}: Props) {
  switch (view) {
    case "applicant-home":
      return <ApplicantHome onNavigate={onNavigate} data-id="element-1530" data-mp="2d4r5qymovz29" />;
    case "event-detail":
      return <EventDetail onNavigate={onNavigate} data-id="element-1531" data-mp="287qvebit4a5c" />;
    case "applicant-auth":
      return <ApplicantAuth onNavigate={onNavigate} data-id="element-1532" data-mp="35og5stltokqc" />;
    case "applicant-form":
      return <ApplicationForm onNavigate={onNavigate} data-id="element-1533" data-mp="30wy4g4fw0i4u" />;
    case "applicant-preview":
      return <ApplicationPreview onNavigate={onNavigate} data-id="element-1534" data-mp="30utqsus6s4rd" />;
    case "submission-success":
      return <SubmissionSuccess onNavigate={onNavigate} data-id="element-1535" data-mp="2qzuh1naeynoy" />;
    case "applicant-dashboard":
      return <ApplicantDashboard onNavigate={onNavigate} applications={applications} published={published} data-id="element-1536" data-mp="2vxnpyo33pvsx" />;
    case "tracking":
      return <TrackingPage onNavigate={onNavigate} applications={applications} published={published} data-id="element-1537" data-mp="2i4o9ojvhvxkb" />;
    case "applicant-certificate":
      return <ApplicantCertificate onNavigate={onNavigate} data-id="element-1538" data-mp="288une8rz4ppc" />;
    default:
      return <ApplicantHome onNavigate={onNavigate} data-id="element-1539" data-mp="28anx5wxvvq1k" />;
  }
}